<div class="title">
  {{ 'raportit.tuloslaskelma' | translate | async }}
</div>
@if (tuloslaskelmanDataObservable | async; as data) {
  @if (!lataa()) {
    @if (data.e == 'a') {
      <div>
        {{ 'raportit.valittu-paivamaara-ei-tilikaudella' | translate | async }}
      </div>
    }
    @if (lastSuccessfullyUpdated()) {
      <div class="gray-text" style="font-size: 11px; text-align: right; line-height: 13px">{{ 'yleiset.paivitetty' | translate | async }} {{ lastSuccessfullyUpdated() | ltimestamptime | async }}</div>
    }
    @if (data.c == 'c4') {
      <table class="report-table" (click)="handleClick($event, data)">
        <thead>
          <tr>
            <td></td>
            <td>
              {{ data.c1.s | lnumberpvml: 'fi' }}<br />
              - {{ data.c1.e | lnumberpvml: 'fi' }}
            </td>
            <td>
              {{ data.c2.s | lnumberpvml: 'fi' }}<br />
              - {{ data.c2.e | lnumberpvml: 'fi' }}
            </td>
            @if (data.c3) {
              <td>
                {{ data.c3.s | lnumberpvml: 'fi' }}<br />
                - {{ data.c3.e | lnumberpvml: 'fi' }}
              </td>
            }
            @if (!data.c3) {
              <td style="width: 135px; text-align: right; white-space: normal; padding-left: 25px">{{ 'raportit.vertailuaikavali-ei-tilikaudella' | translate | async }}</td>
            }
            <td>
              {{ data.c4.s | lnumberpvml: 'fi' }}<br />
              - {{ data.c4.e | lnumberpvml: 'fi' }}
            </td>
          </tr>
        </thead>
        <tbody>
          @for (row of data.r; track trackAccountRowByAccountNumberFn($index, row)) {
            <tr [attr.data-tnro]="row.a" class="report-row-lvl-{{ row.l }} report-row-acc-nmbr-length-{{ row.a.length }}" [class.report-row-expanded]="row.e" [class.report-row-sum]="row.s">
              <td class="n">{{ row.n }}</td>
              <td>{{ row.s1 | lmoney | async }}</td>
              <td>{{ row.s2 | lmoney | async }}</td>
              <td>{{ row.s3 | lmoney | async }}</td>
              <td>{{ row.s4 | lmoney | async }}</td>
            </tr>
            @if (row.e && row.d == undefined) {
              <tr class="report-row-lvl-{{ row.l }}">
                <td colspan="5">
                  <mat-progress-bar mode="indeterminate"></mat-progress-bar>
                </td>
              </tr>
            }
            @if (row.e && row.d) {
              <tr class="report-row-lvl-{{ row.l }}">
                <td colspan="5">
                  @if (row.d.length == 0) {
                    <div>
                      {{ 'raportit.tilille-ei-vienteja' | translate | async }}
                    </div>
                  }
                  @if (row.d.length > 0) {
                    <table>
                      <thead>
                        <tr>
                          <td>{{ 'raportit.laji' | translate | async }}</td>
                          <td>{{ 'raportit.tosite' | translate | async }}</td>
                          <td>{{ 'raportit.pvm' | translate | async }}</td>
                          <td>{{ 'raportit.selite' | translate | async }}</td>
                          <td>{{ 'raportit.alv' | translate | async }}</td>
                          <td>{{ 'raportit.debet' | translate | async }}</td>
                          <td>{{ 'raportit.kredit' | translate | async }}</td>
                          <td>{{ 'raportit.saldo' | translate | async }}</td>
                        </tr>
                      </thead>
                      <tbody [attr.data-n]="row.n">
                        @for (d of row.d; track d; let i = $index) {
                          <tr [attr.data-i]="i">
                            <td [class.projekti-dot]="d.b" [class]="d.b ? 'a' + d.b : null">{{ d.ma }}</td>
                            <td [attr.data-n]="d.n">{{ d.n }}</td>
                            <td>{{ d.p | lnumberpvmlnarrow: 'fi' }}</td>
                            <td>
                              @if (d.a) {
                                <span class="blue-text space-after">{{ d.a }}&nbsp;</span>
                              }
                              @if (d.c) {
                                <span class="cursive-text space-after">{{ d.c }}&nbsp;</span>
                              }
                              {{ d.r }} {{ d.e }}
                            </td>
                            <td>{{ d.v }}</td>
                            <td>{{ d.d | lmoney | async }}</td>
                            <td>{{ d.k | lmoney | async }}</td>
                            <td>{{ d.s | lmoney | async }}</td>
                          </tr>
                        }
                        <tr class="loppusaldo">
                          <td></td>
                          <td></td>
                          <td colspan="2">{{ 'raportit.yhteensa' | translate | async }}</td>
                          <td></td>
                          <td>{{ row.dds | lmoney | async }}</td>
                          <td>{{ row.dks | lmoney | async }}</td>
                          <td>{{ row.dks - row.dds | lmoney | async }}</td>
                        </tr>
                      </tbody>
                    </table>
                  }
                </td>
              </tr>
            }
          }
        </tbody>
      </table>
    }
    @if (data.c == 'c3') {
      <table class="report-table" (click)="handleClick($event, data)">
        <thead>
          <tr>
            <td></td>
            <td>
              {{ data.c1.s | lnumberpvml: 'fi' }}<br />
              - {{ data.c1.e | lnumberpvml: 'fi' }}
            </td>
            <td>
              {{ data.c2.s | lnumberpvml: 'fi' }}<br />
              - {{ data.c2.e | lnumberpvml: 'fi' }}
            </td>
            <td>
              {{ data.c3.s | lnumberpvml: 'fi' }}<br />
              - {{ data.c3.e | lnumberpvml: 'fi' }}
            </td>
          </tr>
        </thead>
        <tbody>
          @for (row of data.r; track trackAccountRowByAccountNumberFn($index, row)) {
            <tr [attr.data-tnro]="row.a" class="report-row-lvl-{{ row.l }} report-row-acc-nmbr-length-{{ row.a.length }}" [class.report-row-expanded]="row.e" [class.report-row-sum]="row.s">
              <td class="n">{{ row.n }}</td>
              <td>{{ row.s1 | lmoney | async }}</td>
              <td>{{ row.s2 | lmoney | async }}</td>
              <td>{{ row.s3 | lmoney | async }}</td>
            </tr>
            @if (row.e && row.d == undefined) {
              <tr class="report-row-lvl-{{ row.l }}">
                <td colspan="4">
                  <mat-progress-bar mode="indeterminate"></mat-progress-bar>
                </td>
              </tr>
            }
            @if (row.e && row.d) {
              <tr class="report-row-lvl-{{ row.l }}">
                <td colspan="4">
                  @if (row.d.length == 0) {
                    <div>
                      {{ 'raportit.tilille-ei-vienteja' | translate | async }}
                    </div>
                  }
                  @if (row.d.length > 0) {
                    <table>
                      <thead>
                        <tr>
                          <td>{{ 'raportit.laji' | translate | async }}</td>
                          <td>{{ 'raportit.tosite' | translate | async }}</td>
                          <td>{{ 'raportit.pvm' | translate | async }}</td>
                          <td>{{ 'raportit.selite' | translate | async }}</td>
                          <td>{{ 'raportit.alv' | translate | async }}</td>
                          <td>{{ 'raportit.debet' | translate | async }}</td>
                          <td>{{ 'raportit.kredit' | translate | async }}</td>
                          <td>{{ 'raportit.saldo' | translate | async }}</td>
                        </tr>
                      </thead>
                      <tbody [attr.data-n]="row.n">
                        @for (d of row.d; track d; let i = $index) {
                          <tr [attr.data-i]="i">
                            <td [class.projekti-dot]="d.b" [class]="d.b ? 'a' + d.b : null">{{ d.ma }}</td>
                            <td [attr.data-n]="d.n">{{ d.n }}</td>
                            <td>{{ d.p | lnumberpvmlnarrow: 'fi' }}</td>
                            <td>
                              @if (d.a) {
                                <span class="blue-text space-after">{{ d.a }}&nbsp;</span>
                              }
                              @if (d.c) {
                                <span class="cursive-text space-after">{{ d.c }}&nbsp;</span>
                              }
                              {{ d.r }} {{ d.e }}
                            </td>
                            <td>{{ d.v }}</td>
                            <td>{{ d.d | lmoney | async }}</td>
                            <td>{{ d.k | lmoney | async }}</td>
                            <td>{{ d.s | lmoney | async }}</td>
                          </tr>
                        }
                        <tr class="loppusaldo">
                          <td></td>
                          <td></td>
                          <td colspan="2">{{ 'raportit.yhteensa' | translate | async }}</td>
                          <td></td>
                          <td>{{ row.dds | lmoney | async }}</td>
                          <td>{{ row.dks | lmoney | async }}</td>
                          <td>{{ row.dks - row.dds | lmoney | async }}</td>
                        </tr>
                      </tbody>
                    </table>
                  }
                </td>
              </tr>
            }
          }
        </tbody>
      </table>
    }
    @if (data.c == 'c2') {
      <table class="report-table" (click)="handleClick($event, data)">
        <thead>
          <tr>
            <td></td>
            <td>
              {{ data.c1.s | lnumberpvml: 'fi' }}<br />
              - {{ data.c1.e | lnumberpvml: 'fi' }}
            </td>
            <td>
              {{ data.c2.s | lnumberpvml: 'fi' }}<br />
              - {{ data.c2.e | lnumberpvml: 'fi' }}
            </td>
          </tr>
        </thead>
        <tbody>
          @for (row of data.r; track trackAccountRowByAccountNumberFn($index, row)) {
            <tr [attr.data-tnro]="row.a" class="report-row-lvl-{{ row.l }} report-row-acc-nmbr-length-{{ row.a.length }}" [class.report-row-expanded]="row.e" [class.report-row-sum]="row.s">
              <td class="n">{{ row.n }}</td>
              <td>{{ row.s1 | lmoney | async }}</td>
              <td>{{ row.s2 | lmoney | async }}</td>
            </tr>
            @if (row.e && row.d == undefined) {
              <tr class="report-row-lvl-{{ row.l }}">
                <td colspan="3">
                  <mat-progress-bar mode="indeterminate"></mat-progress-bar>
                </td>
              </tr>
            }
            @if (row.e && row.d) {
              <tr class="report-row-lvl-{{ row.l }}">
                <td colspan="3">
                  @if (row.d.length == 0) {
                    <div>
                      {{ 'raportit.tilille-ei-vienteja' | translate | async }}
                    </div>
                  }
                  @if (row.d.length > 0) {
                    <table>
                      <thead>
                        <tr>
                          <td>{{ 'raportit.laji' | translate | async }}</td>
                          <td>{{ 'raportit.tosite' | translate | async }}</td>
                          <td>{{ 'raportit.pvm' | translate | async }}</td>
                          <td>{{ 'raportit.selite' | translate | async }}</td>
                          <td>{{ 'raportit.alv' | translate | async }}</td>
                          <td>{{ 'raportit.debet' | translate | async }}</td>
                          <td>{{ 'raportit.kredit' | translate | async }}</td>
                          <td>{{ 'raportit.saldo' | translate | async }}</td>
                        </tr>
                      </thead>
                      <tbody [attr.data-n]="row.n">
                        @for (d of row.d; track d; let i = $index) {
                          <tr [attr.data-i]="i">
                            <td [class.projekti-dot]="d.b" [class]="d.b ? 'a' + d.b : null">{{ d.ma }}</td>
                            <td [attr.data-n]="d.n">{{ d.n }}</td>
                            <td>{{ d.p | lnumberpvmlnarrow: 'fi' }}</td>
                            <td>
                              @if (d.a) {
                                <span class="blue-text space-after">{{ d.a }}</span>
                              }
                              @if (d.c) {
                                <span class="cursive-text space-after">{{ d.c }}</span>
                              }
                              {{ d.r }} {{ d.e }}
                            </td>
                            <td>{{ d.v }}</td>
                            <td>{{ d.d | lmoney | async }}</td>
                            <td>{{ d.k | lmoney | async }}</td>
                            <td>{{ d.s | lmoney | async }}</td>
                          </tr>
                        }
                        <tr class="loppusaldo">
                          <td></td>
                          <td></td>
                          <td colspan="2">{{ 'raportit.yhteensa' | translate | async }}</td>
                          <td></td>
                          <td>{{ row.dds | lmoney | async }}</td>
                          <td>{{ row.dks | lmoney | async }}</td>
                          <td>{{ row.dks - row.dds | lmoney | async }}</td>
                        </tr>
                      </tbody>
                    </table>
                  }
                </td>
              </tr>
            }
          }
        </tbody>
      </table>
    }
    @if (data.c == 'c1') {
      <table class="report-table" (click)="handleClick($event, data)">
        <thead>
          <tr>
            <td></td>
            <td>
              {{ data.c1?.s | lnumberpvml: 'fi' }}<br />
              - {{ data.c1?.e | lnumberpvml: 'fi' }}
            </td>
          </tr>
        </thead>
        <tbody>
          @for (row of data.r; track trackAccountRowByAccountNumberFn($index, row)) {
            <tr [attr.data-tnro]="row.a" class="report-row-lvl-{{ row.l }} report-row-acc-nmbr-length-{{ row.a.length }}" [class.report-row-expanded]="row.e" [class.report-row-sum]="row.s">
              <td class="n">{{ row.n }}</td>
              <td>{{ row.s1 | lmoney | async }}</td>
            </tr>
            @if (row.e && row.d == undefined) {
              <tr class="report-row-lvl-{{ row.l }}">
                <td colspan="2">
                  <mat-progress-bar mode="indeterminate"></mat-progress-bar>
                </td>
              </tr>
            }
            @if (row.e && row.d) {
              <tr class="report-row-lvl-{{ row.l }}">
                <td colspan="2">
                  @if (row.d.length == 0) {
                    <div>
                      {{ 'raportit.tilille-ei-vienteja' | translate | async }}
                    </div>
                  }
                  @if (row.d.length > 0) {
                    <table>
                      <thead>
                        <tr>
                          <td>{{ 'raportit.laji' | translate | async }}</td>
                          <td>{{ 'raportit.tosite' | translate | async }}</td>
                          <td>{{ 'raportit.pvm' | translate | async }}</td>
                          <td>{{ 'raportit.selite' | translate | async }}</td>
                          <td>{{ 'raportit.alv' | translate | async }}</td>
                          <td>{{ 'raportit.debet' | translate | async }}</td>
                          <td>{{ 'raportit.kredit' | translate | async }}</td>
                          <td>{{ 'raportit.saldo' | translate | async }}</td>
                        </tr>
                      </thead>
                      <tbody [attr.data-n]="row.n">
                        @for (d of row.d; track d; let i = $index) {
                          <tr [attr.data-i]="i">
                            <td [class.projekti-dot]="d.b" [class]="d.b ? 'a' + d.b : null">{{ d.ma }}</td>
                            <td [attr.data-n]="d.n">{{ d.n }}</td>
                            <td>{{ d.p | lnumberpvmlnarrow: 'fi' }}</td>
                            <td>
                              @if (d.a) {
                                <span class="blue-text space-after">{{ d.a }} &nbsp;</span>
                              }
                              @if (d.c) {
                                <span class="cursive-text space-after">{{ d.c }} &nbsp;</span>
                              }
                              {{ d.r }} {{ d.e }}
                            </td>
                            <td>{{ d.v }}</td>
                            <td>{{ d.d | lmoney | async }}</td>
                            <td>{{ d.k | lmoney | async }}</td>
                            <td>{{ d.s | lmoney | async }}</td>
                          </tr>
                        }
                        <tr class="loppusaldo">
                          <td></td>
                          <td></td>
                          <td colspan="2">{{ 'raportit.yhteensa' | translate | async }}</td>
                          <td></td>
                          <td>{{ row.dds | lmoney | async }}</td>
                          <td>{{ row.dks | lmoney | async }}</td>
                          <td>{{ row.dks - row.dds | lmoney | async }}</td>
                        </tr>
                      </tbody>
                    </table>
                  }
                </td>
              </tr>
            }
          }
        </tbody>
      </table>
    }
  } @else {
    <mat-spinner style="margin-left: auto; margin-right: auto; margin-top: 20px"></mat-spinner>
  }
}
